export default function getScriptContext () {
    // console.log('SCRIPT-CONTEXT', (window.srcContext) ? window.srcContext : 'gazetadopovo-app')
    return (window.srcContext) ? window.srcContext : 'gazetadopovo-app'
}
